module.exports = __webpack_public_path__ + "static/children-of-dune-304e034b6c28a821a2785a1c30038aaa.jpg";